import { render, staticRenderFns } from "./Dinos.vue?vue&type=template&id=b088e8ea&"
import script from "./Dinos.vue?vue&type=script&lang=ts&"
export * from "./Dinos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports